import React from "react";

interface LogoProps {
  size?: number;
  color?: string;
  title?: string;
}

/**
 * Claude-style radiant starburst mark.
 * Pure inline SVG — no external asset needed.
 */
const ClaudeLogo: React.FC<LogoProps> = ({
  size = 28,
  color = "var(--cl-accent)",
  title = "AI",
}) => {
  const rays = 12;
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 100 100"
      fill="none"
      role="img"
      aria-label={title}
      xmlns="http://www.w3.org/2000/svg"
    >
      {Array.from({ length: rays }).map((_, i) => {
        const angle = (360 / rays) * i;
        const long = i % 2 === 0;
        const h = long ? 41 : 27;
        return (
          <rect
            key={i}
            x={47}
            y={50 - h}
            width={6}
            height={h}
            rx={3}
            fill={color}
            transform={`rotate(${angle} 50 50)`}
          />
        );
      })}
    </svg>
  );
};

export default ClaudeLogo;
